import React, { useEffect, useState, useRef } from 'react';

import timerMp3 from '../../../sounds/mixkit-sport-start-bleeps-918.mp3';
import timerOgg from '../../../sounds/mixkit-sport-start-bleeps-918.ogg';

import dayjs from 'dayjs'

import './AutoProgressTimer.scss'

const AutoProgressTimer = ({ durationInSeconds, onCountdownFinished }) => {
  const remainingRef = useRef(null)
  const [playAudio, setPlayAudio] = useState(false);

  const startCountdown = (secondsToAdd) => {
    const end = dayjs().add(secondsToAdd, 'second');

    requestAnimationFrame(function doWork(){
      let diff = end.diff(dayjs(), 'second')
      if (!!remainingRef) {
        if (diff > 0) {
          remainingRef.current.innerHTML = `${diff}`
        } else {
          remainingRef.current.innerHTML = ` `
        }
      }
      if (Math.floor(diff) === 3) {
        setPlayAudio(true)
      }
      if (diff > 0) {
        requestAnimationFrame(doWork)
      } else {
        onCountdownFinished()
      }
    })
  }

  useEffect(() => {
    console.log('AutoProgressTimer useEffect')
    const secondsToAdd = durationInSeconds ? Math.max([durationInSeconds + 1, 5]) : 10;
    startCountdown(secondsToAdd)
  }, []);

  return (
    <div className="auto-progress-timer--container">
      <h1 ref={remainingRef}> </h1>
      {!!playAudio && (
        <audio style={{ display: 'none' }} autoPlay>
          <source src={timerOgg} type="audio/ogg" />
          <source src={timerMp3} type="audio/mpeg" />
        </audio>
      )}
    </div>
  );
};

export default AutoProgressTimer;
